import { selectLimits } from "../state/selectors/limits";
import { api } from '../constants/order_history_api';
import { httpClient } from "./httpClient";
import log from "./logger/log";
import { updateOrderHistory } from "../state/ducks/order_history";
import { dispatch } from "../state/store";

const getOrderHistory = async (filter) => {
    const url = api.GET_ORDER_HISTORY_LIST_API;

    let postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: filter.sortFilter
    }

    try {
        const data = await httpClient.post(url, postData);
        const orderHistory = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }

        dispatch(updateOrderHistory(orderHistory));
        return orderHistory;
    }
    catch (error) {
        log.error(JSON.stringify(error));
        throw error;
    }
}

const getReport = async (filter) => {
    const url = api.GET_ORDER_HISTORY_REPORT_API;

    // const filter = selectOperationsFilter()(getState());
    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: {}
    }

    try {
        const response = await httpClient.getReport("POST", url, postData);
        return response;
    }
    catch (error) {
        log.error(JSON.stringify(error));
    }
}

const orderHistoryService = {
    getOrderHistory,
    getReport
}

export default orderHistoryService;